module.exports = __webpack_public_path__ + "684d84b6ec52ad057b7f9d5f689d684b.pdf";